const STORAGE_KEY = "my-apis-ui";

const DEFAULT_FILTERS = {
  config: "",
  model: "",
  action: "",
  search: ""
};

const normalizePath = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path;
};

export const isMyApisRoute = (pathname) => {
  const path = normalizePath(pathname);
  return path === "/my-apis" || path.startsWith("/my-apis/");
};

export const loadMyApisPersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveMyApisPersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist my APIs state", error);
  }
};

export const clearMyApisPersistence = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getPersistedMyApisUiState = () => {
  const data = loadMyApisPersistence();
  if (!data) {
    return {
      hasCache: false,
      filters: { ...DEFAULT_FILTERS },
      list: []
    };
  }

  const list = Array.isArray(data.list) ? data.list : [];

  return {
    hasCache: list.length > 0,
    filters: { ...DEFAULT_FILTERS, ...(data.filters || {}) },
    list
  };
};
